// extracted by mini-css-extract-plugin
export default {"nodataMainContainer":"NoData_nodataMainContainer__9B5Ny"};